module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Bold.eot
// module id = 16
// module chunks = 8